import { ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { AuthenticatorInterceptor } from './core/interceptors/authentication.interceptor';
import { RefreshInterceptor } from './core/interceptors/refresh.interceptor';
import { LoggingInterceptor } from './core/interceptors/logging.interceptor';
import { GlobalErrorHandler } from './core/services/global-error-handler';
import { LoadingInterceptor } from './core/interceptors/loading-interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        AuthenticatorInterceptor,
        RefreshInterceptor,
        LoadingInterceptor,
        LoggingInterceptor, // ← traces all HTTP calls
      ])),
    // Replace default ErrorHandler with our structured logging handler
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ]
};